import * as S from './styles';
import InputMask from 'react-input-mask';
import { useEffect, useState } from 'react';
import {
  allowsNegative,
  decimalInputAttrs,
  normalizeDecimal,
  toDecimalDisplay,
} from '../../../Services/decimalInput';

interface IProps {
  autoComplete?: 'on' | 'off';
  type?:
    | 'string'
    | 'number'
    | 'date'
    | 'text'
    | 'email'
    | 'password'
    | 'checkbox';
  placeholder?: string;
  maxLength?: number;
  label?: string;
  step?: string;
  min?: string;
  max?: string;
  disabled?: boolean;
  isInvalid?: boolean;
  size?: 'sm' | 'lg';
  as?: any;
  rows?: number;
  name: string;
  mask?: string;
  defaultValue?: any;
  errors?: any;
  register: any;
  watch?: any;
  setValue?: any;
  setAltValue?: any;
  label2?: string;
  isCurrency?: boolean;
}

export function InputHook({
  label,
  type,
  autoComplete,
  placeholder,
  maxLength,
  step,
  min,
  max,
  disabled,
  as,
  rows,
  name,
  mask,
  defaultValue,
  register,
  errors,
  watch,
  setValue,
  setAltValue,
  label2,
  isCurrency = false,
}: IProps) {
  const errorToDisplay = errors
    ? Object?.keys(errors[0])?.find((key) => key === name)
    : '';

  const [inputValue, setInputValue] = useState<string>('');
  const isDecimal = type === 'number' && !isCurrency;

  useEffect(() => {
    if (defaultValue) {
      setInputValue(
        isCurrency
          ? formatCurrency(defaultValue)
          : isDecimal
            ? toDecimalDisplay(defaultValue)
            : defaultValue.toString()
      );
    }
  }, [defaultValue, isCurrency, isDecimal]);

  const formatCurrency = (value: any) => {
    if (!value) return '0,00';
    const cleanedValue = value.toString().replace(/\D/g, '');
    const number = parseFloat(cleanedValue) / 100;
    return number.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;

    if (isCurrency) {
      value = value.replace(/\D/g, '');
      value = formatCurrency(value);
    }

    if (isDecimal) {
      value = normalizeDecimal(value, allowsNegative(min));
      setInputValue(toDecimalDisplay(value));
      setValue?.(name, value);
      setAltValue && setAltValue(value);
      return;
    }

    setInputValue(value);
    setValue?.(
      name,
      isCurrency
        ? parseFloat(value.replace(/\./g, '').replace(',', '.'))
        : value
    );
    setAltValue && setAltValue(value);
  };

  return (
    <div>
      <div
        style={{
          fontSize: '10px',
          textAlign: 'end',
          paddingBottom: '0.2rem',
          minHeight: '20px',
        }}
      >
        {label2}
      </div>
      <label>
        <div className="label">{label}</div>
        <S.Input
          errorToDisplay={
            errorToDisplay && errors[0][errorToDisplay]?.message.length > 0
          }
        >
          {mask ? (
            <InputMask
              className="inputMask"
              {...register(name)}
              mask={mask}
              defaultValue={defaultValue}
              name={name}
              type="text"
              disabled={disabled}
              autoComplete="off"
              placeholder={placeholder}
              step={step}
              min={min}
              max={max}
            />
          ) : (
            <S.FormInput
              {...register(name)}
              defaultValue={defaultValue}
              name={name}
              as={as}
              type={isDecimal ? decimalInputAttrs.type : type}
              inputMode={isDecimal ? decimalInputAttrs.inputMode : undefined}
              autoComplete={autoComplete}
              placeholder={placeholder}
              maxLength={maxLength}
              step={step}
              min={min}
              max={max}
              disabled={disabled}
              rows={rows}
              value={inputValue}
              onChange={handleChange}
            />
          )}
          {errorToDisplay && (
            <S.Error>{errors[0][errorToDisplay]?.message}</S.Error>
          )}
        </S.Input>
      </label>
    </div>
  );
}
